// extracted by mini-css-extract-plugin
export var bodyRow = "_cu-d";
export var cardColumns = "_cu-e";
export var ellipsesOverflow = "_cu-2";
export var flatBottomCorners = "_cu-3";
export var flatTopCorners = "_cu-4";
export var headerActionsDropdown = "_cu-f";
export var headerBottomRow = "_cu-c";
export var headerTopRow = "_cu-b";
export var orderDetailsWrapper = "_cu-0";
export var orderInfoContainer = "_cu-1";
export var productDetails = "_cu-9";
export var productImage = "_cu-5";
export var responsiveTable = "_cu-8";
export var shipmentContainer = "_cu-a";
export var tableBottomLeft = "_cu-6";
export var tableBottomRight = "_cu-7";
export var trackingLink = "_cu-g";